(() => {
  const initPlans = (section) => {
    if (!section || section.dataset.dtc3PlansReady === 'true') return;

    const tabs = Array.from(section.querySelectorAll('[data-dtc3-plan-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-dtc3-plan-panel]'));
    const billingOptions = Array.from(section.querySelectorAll('[data-dtc3-billing-option]'));
    const footnote = section.querySelector('[data-dtc3-plans-footnote]');

    const selectTab = (nextIndex, moveFocus = false) => {
      tabs.forEach((tab, index) => {
        const isActive = index === nextIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        panels[index].classList.toggle('is-active', isActive);
      });

      if (footnote) footnote.classList.toggle('is-mobile-hidden', nextIndex !== 0);

      if (moveFocus) tabs[nextIndex].focus();
    };

    if (tabs.length && tabs.length === panels.length) {
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(index));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          selectTab(nextIndex, true);
        });
      });
    }

    const selectBillingPeriod = (card, period) => {
      const cardOptions = Array.from(card.querySelectorAll('[data-dtc3-billing-option]'));
      const cardPrices = Array.from(card.querySelectorAll('[data-dtc3-plan-price]'));
      const button = card.querySelector('[data-dtc3-plan-button]');

      cardOptions.forEach((option) => {
        const isActive = option.dataset.dtc3BillingOption === period;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-pressed', String(isActive));
      });

      cardPrices.forEach((price) => {
        price.hidden = price.dataset.dtc3PlanPrice !== period;
      });

      if (button) {
        const nextUrl = period === 'month' ? button.dataset.dtc3MonthUrl : button.dataset.dtc3YearUrl;
        if (nextUrl) button.setAttribute('href', nextUrl);
      }
    };

    billingOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const card = option.closest('[data-dtc3-plan-panel]');
        if (card) selectBillingPeriod(card, option.dataset.dtc3BillingOption);
      });
    });

    section.dataset.dtc3PlansReady = 'true';
  };

  const initAllPlans = (root = document) => {
    root.querySelectorAll('[data-dtc3-plans]').forEach(initPlans);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllPlans(), { once: true });
  } else {
    initAllPlans();
  }

  document.addEventListener('shopify:section:load', (event) => initAllPlans(event.target));
})();
